module.exports = __webpack_public_path__ + "static/media/more_games_zh.8915353c.png";